import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  // Remplacez ces valeurs par celles de votre configuration Firebase
  apiKey: "AIzaSyAwGJpAanjqQBTk4kmLKH_JDmsXuCPyBfw",
  authDomain: "rezone-gaming.firebaseapp.com",
  projectId: "rezone-gaming",
  storageBucket: "rezone-gaming.firebasestorage.app",
  messagingSenderId: "361805652986",
  appId: "1:361805652986:web:dc32c0ca8ce375d7fb3a43"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth with French language
export const auth = getAuth(app);
auth.languageCode = 'fr'; // Définir la langue en français

// Initialize Storage
export const storage = getStorage(app);

// Initialize Analytics
import { getAnalytics } from "firebase/analytics";
export const analytics = getAnalytics(app);

// Initialize Messaging (REMOVED: Legacy Code)
// import { getMessaging } from "firebase/messaging";
// export const messaging = getMessaging(app);

export default app;
